// pages/SchedulePage.tsx
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { HeartIcon } from "lucide-react";
import leftFlower from "../assets/leftFlower.png";
import rightFlower from "../assets/rightFlower.png";

const SchedulePage = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const openMap = (address: string) => {
    const encodedAddress = encodeURIComponent(address);
    window.open(
      `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`,
      "_blank"
    );
  };

  const addToCalendar = (event: {
    title: string;
    startDate: string;
    endDate: string;
    location: string;
    description: string;
  }) => {
    const { title, startDate, endDate, location, description } = event;
    const googleCalendarUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(
      title
    )}&dates=${startDate}/${endDate}&location=${encodeURIComponent(
      location
    )}&details=${encodeURIComponent(description)}`;
    window.open(googleCalendarUrl, "_blank");
  };

  return (
    <section className="w-full bg-white py-10 px-6 relative ">
      {/* Decorative floral elements - Right top (BEHIND content) */}
      <img
        src={rightFlower}
        alt=""
        className="absolute right-0 top-0 w-32 md:w-60 opacity-80 pointer-events-none z-0"
      />

      {/* Decorative floral elements - Left bottom (BEHIND content) */}
      <img
        src={leftFlower}
        alt=""
        className="absolute left-0 bottom-[0%] md:bottom-[-40%] w-32 md:w-60 opacity-80 pointer-events-none z-0 overflow-hidden"
      />
      <div className="max-w-3xl mx-auto text-center">
        {/* Main Date Header */}
        <h1
          data-aos="fade-down"
          className="text-3xl md:text-5xl bg-gradient-to-r from-[#C49355] to-[#E8B46A] bg-clip-text text-transparent mb-12"
          // style={{
          //   fontFamily: "'Times New Roman', Times, serif",
          //   fontWeight: 400,
          //   fontStyle: "italic",
          // }}
        >
          Wednesday, April 22, 2026
        </h1>

        {/* Wedding Ceremony Section */}
        <div data-aos="fade-up" className="mb-16">
          {/* Hearts Divider */}
          <div className="mb-8 m-auto w-full flex justify-center">
            <HeartIcon />
          </div>

          {/* Event Title */}
          <h2
            className="text-2xl md:text-3xl text-gray-800 font-semibold mb-2"
            style={{
              fontFamily: "'Times New Roman', Times, serif",
            }}
          >
            Wedding Ceremony
          </h2>

          {/* Time */}
          <p className="text-gray-600 mb-6">4:00 pm - 5:00 pm</p>

          {/* Venue Name */}
          <p
            className="text-gray-700 font-medium text-base"
            style={{
              fontFamily: "'Times New Roman', Times, serif",
            }}
          >
            Elpis Christian Ministries
          </p>

          {/* Address */}
          <p
            className="text-gray-600 italic underline mb-6 text-base"
            style={{
              fontFamily: "'Times New Roman', Times, serif",
            }}
          >
            8 Oaks Lane, London, England IG2 7PL, United Kingdom
          </p>

          {/* Dress Code */}
          <p className="text-gray-600 mb-4">
            We'd love for our guests to join us in cocktail formal attire
          </p>

          {/* Arrival Note */}
          <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
            Please arrive at the ceremony by 3:45pm to ensure you are
            comfortably seated before the ceremony begins promptly by 4:00pm
          </p>

          {/* Buttons */}
          <div className="flex items-center justify-center gap-4">
            <button
              onClick={() =>
                openMap("8 Oaks Lane, London, England IG2 7PL, United Kingdom")
              }
              className="bg-[#3d3d3d] hover:bg-[#2d2d2d] text-white px-10 py-3 text-base transition-colors duration-300"
            >
              Map
            </button>
            <button
              onClick={() =>
                addToCalendar({
                  title: "Wedding Ceremony - Joseph & Jennifer",
                  startDate: "20260422T153000",
                  endDate: "20260422T163000",
                  location:
                    "Elpis Christian Ministries, 8 Oaks Lane, London, England IG2 7PL",
                  description:
                    "Wedding Ceremony of Joseph Sani & Jennifer Iloanyionwu",
                })
              }
              className="bg-[#3d3d3d] hover:bg-[#2d2d2d] text-white px-6 py-3 text-base transition-colors duration-300"
            >
              Add to calendar
            </button>
          </div>
        </div>

        {/* Reception Section */}
        <div data-aos="fade-up" data-aos-delay="200">
          {/* Hearts Divider */}
          <div className="mb-8 m-auto w-full flex justify-center">
            <HeartIcon />
          </div>

          {/* Event Title */}
          <h2
            className="text-2xl md:text-3xl text-gray-800 font-semibold mb-2"
            style={{
              fontFamily: "'Times New Roman', Times, serif",
            }}
          >
            Reception
          </h2>

          {/* Time */}
          <p className="text-gray-600 mb-6">6:00 pm - 10:00 pm</p>

          {/* Venue Name */}
          <p
            className="text-gray-700 font-medium text-base"
            style={{
              fontFamily: "'Times New Roman', Times, serif",
            }}
          >
            Venue 254
          </p>

          {/* Address */}
          <p
            className="text-gray-600 italic underline mb-8 text-base"
            style={{
              fontFamily: "'Times New Roman', Times, serif",
            }}
          >
            350 Katherine Road, London, England E7 8NW, United Kingdom
          </p>

          {/* Buttons */}
          <div className="flex items-center justify-center gap-4">
            <button
              onClick={() =>
                openMap(
                  "350 Katherine Road, London, England E7 8NW, United Kingdom"
                )
              }
              className="bg-[#3d3d3d] hover:bg-[#2d2d2d] text-white px-10 py-3 text-base transition-colors duration-300"
            >
              Map
            </button>
            <button
              onClick={() =>
                addToCalendar({
                  title: "Wedding Reception - Joseph & Jennifer",
                  startDate: "20260422T180000",
                  endDate: "20260422T220000",
                  location:
                    "Venue 254, 350 Katherine Road, London, England E7 8NW",
                  description:
                    "Wedding Reception of Joseph Sani & Jennifer Iloanyionwu",
                })
              }
              className="bg-[#3d3d3d] hover:bg-[#2d2d2d] text-white px-6 py-3 text-base transition-colors duration-300"
            >
              Add to calendar
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SchedulePage;
